import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {};

const appSlice = createSlice({
  name: "app",
  initialState: INITIAL_STATE,
  reducers: {
    resetData: (state) => {
      return {
        ...state,
      };
    },
  },
});

export const { resetData } = appSlice.actions;

export default appSlice.reducer;
